import { defineStore } from 'pinia';
import { authService } from '@/services/auth';

export const useOutlookStore = defineStore('outlook', {
  state: () => ({
    senderMail: '',
    attachments: {},
    isEmailView: false,
  }),
  getters: {
    getSenderMail: (state) => state.senderMail,
    getAttachments: (state) => state.attachments,
    getIsEmailView: (state) => state.isEmailView,
  },
  actions: {
    async updateEmailStore(item) {
      await this.setAttachments(item.attachments);
      await this.filterSenderMail(item);
    },

    setAttachments(attachments) {
      this.attachments = attachments;
    },

    setSenderMail(search) {
      this.senderMail = search;
    },

    async filterSenderMail(item) {
      let senderMail = item.sender && item.sender.emailAddress;
      const { username } = authService.getProfile();

      // EMAIL VIEW
      if (senderMail) {
        this.isEmailView = true;
        if (senderMail === username) senderMail = item.to[0].emailAddress;
      }
      // CALENDAR VIEW
      else if (item.itemType === 'appointment') {
        this.isEmailView = false;
        senderMail =
          item.organizer.emailAddress === username
            ? item.requiredAttendees[0].emailAddress
            : item.organizer.emailAddress;
      }
      this.senderMail = senderMail;
    },
  },
});
